<div class="page tracking history">
  <app-left-report [visibleComponents]="'drivers'" [showDeviceMenu]="false"></app-left-report>

  <div class="vert_collapser" id="vert_collapser" onclick="collapseTrack()">
    <span><i></i></span>
  </div>

  <div class="righttrack">
    <div class="bottomright" id="bottomright">
      <div class="btns">
        <div class="btn_tabs">
        </div>
        <div>
          <input type="text" class="dtpickerupleft" value="" />
        </div>
        <button id="setintervalbtn" class="btn_blue">{{'Apply'|translate }}</button>
      </div>
      <div class="rightreport">
        <div class="tablewrap resizetable">
          <div class="table" id="maintable_print">
            <table>
              <tr><th id="reporttitle" colspan="5"></th></tr>
            </table>
            <div class="reportinfo">
              <div id="maintable" class="resizetable"></div>
            </div>
          </div>
          <app-pagination [viewmode]="'print reports excel'" [printElementID]="'maintable_print'"></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
